module.exports = __webpack_public_path__ + "img/mini-005.f83241c3.jpg";